import { FC } from 'react';

import { Operatory } from 'interfaces/operatory';

import AssignedSelectSection from '../AssignedSelectSection/AssignedSelectSection';
import { Specialty } from 'interfaces/specialty';
import { uniqBy } from 'lodash';

interface AssignedDoctorChairSectionProps {
  control: any;
  doctors: {
    id: string;
    avatar: string;
    firstName: string;
    name: string;
    title: string;
    specialist: string;
    specialties: Specialty[];
    operatories: Operatory[];
  }[];
}

const AssignedDoctorChairSection: FC<AssignedDoctorChairSectionProps> = ({
  control,
  doctors = [],
}) => {
  const operatoriesByAllDoctors = doctors.flatMap((item) => item.operatories);
  const operatories = uniqBy(operatoriesByAllDoctors, (item) => item.id);

  return (
    <AssignedSelectSection
      control={control}
      name="doctorChairs"
      title="Doctor Chairs Assigned to Split Scheduling"
      tooltipId="doctor-chair-split-scheduling"
      tooltipText="Assigning chairs to specific recare services"
      placeholder="Select Doctor Chairs"
      items={operatories ?? []}
      renderItemLabel={(operatory: Operatory) => (
        <span className="truncate">
          {operatory.displayName || operatory.name}
        </span>
      )}
    />
  );
};

export default AssignedDoctorChairSection;
